import React, {
  useEffect,
  useState,
} from 'react';

import useFindDefaultReport from 'data/user/reports/useFindDefaultReports';
import { PageMainLayout } from 'layout/PageLayout';
import { menuReport } from 'nav/menu';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';

import ReportBuilder from '../../report/ReportBuilder';
import TakeStockReportHome from '../../reportTakeStock/TakeStockReportHome';

export default function Reports() {

  useFindDefaultReport()

  const [infoSel,setInfoSel] = useState("AutonomyReports")
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname.split("/")
  const subPage = pathname[2]
  

  useEffect(()=>{
   if (subPage){
   const menuSel = menuReport.filter(obj=>obj.link===subPage)[0]?.name
   setInfoSel(menuSel)}
   else{
    navigate(`/Report/AutonomyReports`)
    setInfoSel("AutonomyReports")
   }
  },[pathname])
 
  return (
    <PageMainLayout pageName='Reports' menuOptions={menuReport} menuSel={infoSel}>
    {subPage==="ReportBuilder" && <ReportBuilder/>}
      {subPage==="AutonomyReports" && <TakeStockReportHome/>}
    </PageMainLayout>
  )
}

